/* eslint-disable */
/* @see https://stackoverflow.com/questions/2557247/easiest-way-to-retrieve-cross-browser-xmlhttprequest */
export function sendRequest(options) {
  let {url, success, error, postData} = options;
  const req = createXMLHTTPObject();
  if (!req) return;
  const method = postData ? "POST" : "GET";
  req.open(method, url, true);
  // Setting the user agent is not allowed in most modern browsers It was
  // a requirement for some Internet Explorer versions a long time ago.
  // There is no need for this header if you use Internet Explorer 7 or
  // above (or any other browser)
  // req.setRequestHeader('User-Agent','XMLHTTP/1.0');
  if (postData)
    req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  req.onreadystatechange = function() {
    if (req.readyState !== 4) return;
    if (req.status !== 200 && req.status !== 304) {
      error('HTTP error ' + req.status);
      return;
    }
    success(req);
  };
  if (req.readyState === 4) return;
  req.send(postData);
}

var XMLHttpFactories = [
  function() {
    return new XMLHttpRequest();
  },
  function() {
    return new ActiveXObject("Msxml3.XMLHTTP");
  },
  function() {
    return new ActiveXObject("Msxml2.XMLHTTP.6.0");
  },
  function() {
    return new ActiveXObject("Msxml2.XMLHTTP.3.0");
  },
  function() {
    return new ActiveXObject("Msxml2.XMLHTTP");
  },
  function() {
    return new ActiveXObject("Microsoft.XMLHTTP");
  }
];

function createXMLHTTPObject() {
  let xmlhttp = false;
  for (let i = 0; i < XMLHttpFactories.length; i++) {
    try {
      xmlhttp = XMLHttpFactories[i]();
    } catch (e) {
      continue;
    }
    break;
  }
  return xmlhttp;
}
